<template>
  <div
    ref="frisbuy-widget-gallery"
    class="frisbuy-shop-the-look__image-colage"
    :style="[galleryStyle]"
  >
    <div
      v-if="settings.gallery.customStyles"
      v-html="settings.gallery.customStyles"
    ></div>

    <div
      v-if="settings.gallery.header.html"
      v-html="settings.gallery.header.html"
    ></div>

    <TileWithoutPopup
      class="frisbuy-scroll-wrapper"
      :settings="propSettings"
      :mobileSettings="mobileSettings"
      :postList="postList"
      :post="currentPost"
      :postIndex="currentPostIndex"
      :popupText="popupText"
      @changePost="
        (direction) =>
          selectPost(
            postList[currentPostIndex + direction],
            currentPostIndex + direction
          )
      "
    />
  </div>
</template>

<style scoped lang="scss">
.frisbuy-shop-the-look__image-colage {
  font-family: Inter, sans-serif;
}
</style>

<script>
import TileWithoutPopup from "./TileWithoutPopup.vue";
import defaultGallery from "../../gallery/gallery.vue";

export default {
  extends: defaultGallery,

  components: {
    TileWithoutPopup,
  },

  props: {
    popupText: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {};
  },

  created() {
    this.selectPost(this.postList[0], 0);
  },

  methods: {
    scrollHandler() {
      const popupElement = this.widgetRefElement.querySelector(
        ".frisbuy-scroll-wrapper"
      );

      const firstItem = this.widgetRefElement.querySelector(
        ".frisbuy-gallery-post"
      );

      const InView5SecHandler = () => {
        this.had5SecInView = true;
        this.sendAnaliticEvent(
          "Eyesight5Sec",
          window.location.href,
          true,
          true
        );
      };

      this.$nextTick(() => {
        if (
          !this.had5SecInView &&
          /*
            NOTE: ImageCollage view is too large to capture isElementInView with "full === true"
            To fix it, I changed the element to check
          */
          this.isElementInView(popupElement, true)
        ) {
          window.clearTimeout(this.inViewTimeout);

          this.inViewTimeout = setTimeout(InView5SecHandler, 5000);
        } else {
          window.clearTimeout(this.inViewTimeout);
        }

        if (
          !this.hadSeen &&
          /*
            NOTE: ImageCollage view is too large to capture isElementInView with "full === true"
            To fix it, I changed the element to check
          */
          this.isElementInView(firstItem || popupElement, true)
        ) {
          this.hadSeen = true;
          this.sendAnaliticEvent("Eyesight", window.location.href, true, true);
        }
      });
    },
  },
};
</script>
